/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/filter.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * List of integers.
 * @export
 * @interface PredicateIntValues
 */
export interface PredicateIntValues {
  /**
   *
   * @type {Array<number>}
   * @memberof PredicateIntValues
   */
  values?: Array<number>;
}

/**
 * Check if a given object implements the PredicateIntValues interface.
 */
export function instanceOfPredicateIntValues(value: object): value is PredicateIntValues {
  return true;
}

export function PredicateIntValuesFromJSON(json: any): PredicateIntValues {
  return PredicateIntValuesFromJSONTyped(json, false);
}

export function PredicateIntValuesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PredicateIntValues {
  if (json == null) {
    return json;
  }
  return {
    values: json['values'] == null ? undefined : json['values'],
  };
}

export function PredicateIntValuesToJSON(json: any): PredicateIntValues {
  return PredicateIntValuesToJSONTyped(json, false);
}

export function PredicateIntValuesToJSONTyped(
  value?: PredicateIntValues | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    values: value['values'],
  };
}
